import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const clients = [
  {
    id: "bms",
    name: "BMS",
    logo: "/logos/bms-logo.png",
  },
  {
    id: "calenso",
    name: "Calenso",
    logo: "/partner-calenso.png",
  },
  {
    id: "visualinfo",
    name: "Visual Info",
    logo: "/partner-visualinfo.png",
  },
  {
    id: "myexhibition",
    name: "my Exhibition",
    logo: "/partner-myexhibition.png",
  },
  {
    id: "hegias",
    name: "Hegias",
    logo: "/partner-hegias.png",
  },
  {
    id: "actarion",
    name: "Actarion",
    logo: "/partner-actarion.png",
  },
];

export const ClientsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section
      className="py-16 lg:py-20 bg-white border-t border-b border-lab-border"
      data-testid="clients-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="label-text">Vertrauen von</span>
          <h3 className="font-playfair text-2xl lg:text-3xl font-semibold text-lab-primary mt-3">
            Unsere Kunden & Partner
          </h3>
        </motion.div>

        {/* Logos */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : { opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-wrap items-center justify-center gap-10 lg:gap-14"
        >
          {clients.map((client, index) => (
            <motion.div
              key={client.id}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 * index }}
              className="grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-300"
              data-testid={`client-logo-${client.id}`}
            >
              <img
                src={client.logo}
                alt={client.name}
                loading="lazy"
                className="h-10 lg:h-12 max-w-[140px] lg:max-w-[160px] w-auto object-contain"
              />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ClientsSection;
